import { getAppClient, ApiErrorResponse, handleError } from './network_util'

/**
 * 画像をダウンロードする
 * @param imageUrl 画像のURL
 * @param fileName ファイル名
 */
export const downloadImage = async (imageUrl: string, fileName: string): Promise<void> => {
  const apiClient = getAppClient()

  await apiClient.storage
    .downloadImageList(
      { url: imageUrl },
      { format: 'blob' }
    )
    .then((response) => {
      const blob = response.data as Blob
      const url = window.URL.createObjectURL(blob)

      const a = document.createElement('a')
      a.href = url
      a.download = `${fileName}.png`

      document.body.appendChild(a)
      a.click()

      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    })
    .catch((e: ApiErrorResponse) => {
      console.error('ダウンロードに失敗しました。', e)
    })
}
